export const routes = {
  home: '/',
  catalogList: '/catalog/:type',
  catalogConfig: '/catalog/:type/:id/config',
  catalogItemList: '/catalog/:type/:id/:parentId/items',
  catalogItemDetail: '/catalog/:type/:id/:parentId/items/:itemId',
}
